import { useEffect, useState } from "react";

let ButtonLike = ({
  liked,
  postId,
  deleteLikePost,
  handleLikePost,
  userObject,
  buttonStyle,
  buttonLikedSource,
  buttonUnlikedSource,
  children,
  likedPosts,
  fetchedLikes,
  lastLikeDeleted,
  navigate,
  setLikedPosts,
  postLike,
  updateLikePost,
  voteUpdating,
}) => {
  let [like, setLike] = useState(false);
  let [likesQuantity, setLikesQuantity] = useState(postLike);
  let [likeDescription, setLikeDescription] = useState("");
  let [voteUpdatingLocal, setVoteUpdatingLocal] = useState(voteUpdating);

  useEffect(() => {
    setVoteUpdatingLocal(voteUpdating);
  }, [voteUpdating]);

  useEffect(() => {
    if (fetchedLikes) {
      const userLike = likedPosts.find((post) => post.post_id === postId);
      if (userLike) setLike(true);
    }
  }, [fetchedLikes]);

  useEffect(() => {
    if (likesQuantity === 0) {
      return;
    } else if (likesQuantity === 1) {
      setLikeDescription("shunk");
    } else {
      setLikeDescription("shunks");
    }
  }, [likesQuantity]);

  let buttonLikeWorking = function () {
    if (like) {
      deleteLikePost(postId);
      setLikedPosts(likedPosts.filter((post) => post.post_id != postId));
      updateLikePost(postId, postLike, false);
      setLikesQuantity(likesQuantity - 1);
      setLike(!like);
    } else if (!like) {
      handleLikePost(userObject.id, postId);
      updateLikePost(postId, postLike, true);
      setLikesQuantity(likesQuantity + 1);
      setLike(!like);
    }
  };

  return (
    <div className="button-likes-area">
      <button
        disabled={voteUpdatingLocal}
        onClick={buttonLikeWorking}
        className={`button-app button-like ${buttonStyle} ${
          like ? "no-opacity" : null
        } `}
      >
        <img src={like ? buttonLikedSource : buttonUnlikedSource} />
        {children}
      </button>
      <span className={like ? "user-liked" : "user-no-liked"}>
        {likesQuantity ? `${likesQuantity} ${likeDescription}` : null}
      </span>
    </div>
  );
};

export default ButtonLike;
